import styled from 'styled-components';

import { Table } from '@dreryk/react-components';

export const StyledSearchDocumentTemplatesTable = styled(Table)`
   [data-testcomponent='TableCell'] [name='content'] {
      border-bottom: none;
      margin-bottom: -20px;
   }
` as typeof Table;
